import { render, staticRenderFns } from "./MovementUploadStepper.vue?vue&type=template&id=3871f515&scoped=true"
import script from "./MovementUploadStepper.vue?vue&type=script&lang=js"
export * from "./MovementUploadStepper.vue?vue&type=script&lang=js"
import style0 from "./MovementUploadStepper.vue?vue&type=style&index=0&id=3871f515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3871f515",
  null
  
)

export default component.exports